import * as Api from "api";
import {
  CREATE_INSTRUMENT,
  DELETE_INSTRUMENT,
  GET_INSTRUMENTS,
  GET_INSTRUMENT_BY_ID,
  GET_NESTED_INSTRUMENTS,
  UPDATE_INSTRUMENT,
} from "constants/instruments";
import { networkAction } from "helpers/network/networkAction";

export const getInstruments = () => async (dispatch) =>
  networkAction(dispatch, GET_INSTRUMENTS, Api.getInstruments, []);

export const getNestedInstruments = (nested) => async (dispatch) =>
  networkAction(dispatch, GET_NESTED_INSTRUMENTS, Api.getNestedInstruments, [
    nested,
  ]);

export const getInstrumentById = (id) => async (dispatch) =>
  networkAction(dispatch, GET_INSTRUMENT_BY_ID, Api.getInstrumentById, [id]);

export const deleteInstrument = (id) => async (dispatch) =>
  networkAction(dispatch, DELETE_INSTRUMENT, Api.deleteInstrument, [id]);

export const createInstrument = (body) => async (dispatch) =>
  networkAction(dispatch, CREATE_INSTRUMENT, Api.createInstrument, [body]);

export const updateInstrument = (id, body) => async (dispatch) =>
  networkAction(dispatch, UPDATE_INSTRUMENT, Api.updateInstrument, [id, body]);
